module.exports = __webpack_public_path__ + "img/bras_7kl.a6d04e14.jpg";